import { useRef } from 'react'

import { useOnScreen } from '../useOnScreen'

export function useContentEdgesIntersection({ intersectionDeps }) {
  const topEndIntersectionRef = useRef(null)
  const bottomEndIntersectionRef = useRef(null)

  const isIntersectingTopEnd = useOnScreen({
    deps: intersectionDeps,
    initialValue: true,
    ref: topEndIntersectionRef,
  })
  const isIntersectingBottomEnd = useOnScreen({
    deps: intersectionDeps,
    initialValue: true,
    ref: bottomEndIntersectionRef,
  })

  return {
    bottomEndIntersectionRef,
    isIntersectingBottomEnd,
    isIntersectingTopEnd,
    topEndIntersectionRef,
  }
}
